var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBinRed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_31951",
    "data-name": "Group 31951",
    transform: "translate(18 18) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_853",
    "data-name": "Group 853",
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_347",
    "data-name": "Rectangle 347",
    width: 18,
    height: 18,
    fill: "#92e4f1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_868",
    "data-name": "Group 868",
    transform: "translate(15.906 17.25) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66046",
    "data-name": "Path 66046",
    d: "M9.765,0V9a2.358,2.358,0,0,1-2.357,2.35H3.367A2.358,2.358,0,0,1,1.01,9V0H0V9a3.363,3.363,0,0,0,3.367,3.361H7.408A3.363,3.363,0,0,0,10.776,9V0Z",
    transform: "translate(1.519 3.973)",
    fill: "#e77b85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66047",
    "data-name": "Path 66047",
    d: "M7.577,12.695H3.536A3.536,3.536,0,0,1,0,9.166V0H1.347V9.166a2.188,2.188,0,0,0,2.189,2.182H7.577A2.188,2.188,0,0,0,9.765,9.166V0h1.347V9.166a3.536,3.536,0,0,1-3.536,3.529M.337.337V9.166a3.2,3.2,0,0,0,3.2,3.192H7.577a3.2,3.2,0,0,0,3.2-3.192V.337H10.1V9.166a2.525,2.525,0,0,1-2.526,2.519H3.536A2.525,2.525,0,0,1,1.01,9.166V.337Z",
    transform: "translate(1.35 3.805)",
    fill: "#e77b85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66048",
    "data-name": "Path 66048",
    d: "M4.721,0H3.361A3.361,3.361,0,0,0,0,3.361v.31H1.017v-.31A2.34,2.34,0,0,1,3.361,1.024h1.36A2.34,2.34,0,0,1,7.065,3.361v.31H8.082v-.31A3.361,3.361,0,0,0,4.721,0",
    transform: "translate(2.866 0.168)",
    fill: "#e77b85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66049",
    "data-name": "Path 66049",
    d: "M8.418,4.007H7.065V3.529A2.175,2.175,0,0,0,4.889,1.36H3.53A2.175,2.175,0,0,0,1.354,3.529v.478H0V3.529A3.533,3.533,0,0,1,3.53,0h1.36A3.533,3.533,0,0,1,8.418,3.529ZM7.4,3.67h.68V3.529A3.2,3.2,0,0,0,4.889.337H3.53A3.2,3.2,0,0,0,.337,3.529V3.67h.68V3.529A2.512,2.512,0,0,1,3.53,1.024h1.36A2.512,2.512,0,0,1,7.4,3.529Z",
    transform: "translate(2.697)",
    fill: "#e77b85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66050",
    "data-name": "Path 66050",
    d: "M12.97,1.01H.505A.505.505,0,0,1,.505,0H12.97a.505.505,0,0,1,0,1.01",
    transform: "translate(0.168 3.032)",
    fill: "#e77b85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66051",
    "data-name": "Path 66051",
    d: "M13.139,1.347H.673A.673.673,0,0,1,.673,0H13.139a.673.673,0,1,1,0,1.347M.673.337a.337.337,0,0,0,0,.673H13.139a.337.337,0,0,0,0-.673Z",
    transform: "translate(0 2.864)",
    fill: "#e77b85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66052",
    "data-name": "Path 66052",
    d: "M.505,5.244A.505.505,0,0,1,0,4.739V.505a.505.505,0,1,1,1.01,0V4.739a.505.505,0,0,1-.505.505",
    transform: "translate(5.054 6.946)",
    fill: "#e77b85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66053",
    "data-name": "Path 66053",
    d: "M.673,5.581A.674.674,0,0,1,0,4.908V.673a.673.673,0,1,1,1.347,0V4.908a.674.674,0,0,1-.673.673m0-5.244A.337.337,0,0,0,.337.673V4.908a.337.337,0,0,0,.673,0V.673A.337.337,0,0,0,.673.337",
    transform: "translate(4.885 6.777)",
    fill: "#e77b85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66054",
    "data-name": "Path 66054",
    d: "M.505,5.244A.505.505,0,0,1,0,4.739V.505a.505.505,0,1,1,1.01,0V4.739a.505.505,0,0,1-.505.505",
    transform: "translate(7.748 6.946)",
    fill: "#e77b85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66055",
    "data-name": "Path 66055",
    d: "M.673,5.581A.674.674,0,0,1,0,4.908V.673a.673.673,0,1,1,1.347,0V4.908a.674.674,0,0,1-.673.673m0-5.244A.337.337,0,0,0,.337.673V4.908a.337.337,0,0,0,.673,0V.673A.337.337,0,0,0,.673.337",
    transform: "translate(7.579 6.777)",
    fill: "#e77b85"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinRed);
export default __webpack_public_path__ + "static/media/bin-red.d207fa72b7a3707df325f27f5c1bfa81.svg";
export { ForwardRef as ReactComponent };